const defaultOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric"
};

export function formatDate(intl, date, options = {}, defaults = true) {
  return intl.formatDate(date, {
    // This is to be used with our own parseDate function that creates UTC
    // dates from time-zone offseted ones, because the date-fns/parse function
    // does not support timezones at the moment.
    // timeZone: "UTC",
    ...(defaults ? defaultOptions : {}),
    ...options
  });
}

export function formatTime(intl, time, options = {}) {
  const formattedTime = intl.formatTime(time, {
    hour: "2-digit",
    minute: "2-digit",
    // This is to be used with our own parseDate function that creates UTC
    // dates from time-zone offseted ones, because the date-fns/parse function
    // does not support timezones at the moment.
    // timeZone: "UTC",
    ...options
  });

  return formattedTime.replace(/:/, "H");
}
